import { combineReducers } from 'redux';
import theme from './Theme';
import user from './User';
import users from './Users';
import faxes from './Faxes';
import numbers from './Numbers';
import companies from './Companies';
import companyGroup from './CompanyGroups';
import boxes from './Boxes';
import boxesSerial from './BoxesSerial';
import allBoxes from './AllBoxes';
import totalBoxes from './BoxCount';
import unassignedBoxes from './UnassignedBoxes';
import obis from './obis';
import boxDetails from './BoxDetails';
import proposals from './Proposals';
import proposalSign from './ProposalsSign';
import modifyProducts from './ModifyProducts';
import analytics from './Analytics';
import calls from './Calls';
import boxesList from './BoxesList';
import companiesList from './CompaniesList';
import groupFilteredCompanies from './GroupsFilteredCompanies';
import companyGroupList from './CompanyGroupList';
import enterpriseAdmins from './EnterpriseAdmins';
import vmails from './Vmails';
import provisioning from './Provisioning';
import deleteMode from './DeleteMode';
import home from './Home';
import boxNotes from './BoxNotes';
import boxLogs from './BoxLogs';
import phone from './Phone';
import epikBoxLocations from './EpikBoxLocations';
import companyGroupListDropdown from './CompanyGroupListDropdown';
import priSipData from './PriSipData';
import alarmRelayStatus from './Numbers/alarmRelayStatus';
import requests from './RequestsUsers';
import tdmRoutes from './Numbers/tdmRoutes';
import { favoriteBoxes, getSetFavBoxes } from './FavoriteBoxes';
import favoriteBoxesList from './FavoriteBoxesList';
import permissionGroups from './PermissionGroups';
import permissionGroup from './PermissionGroup';
import adminFlags from './AdminFlags';

export default combineReducers({
  boxes,
  favoriteBoxes,
  favoriteBoxesList,
  getSetFavBoxes,
  boxesSerial,
  user,
  users,
  faxes,
  numbers,
  theme,
  companies,
  companyGroup,
  groupFilteredCompanies,
  obis,
  boxDetails,
  adminFlags,
  proposals,
  proposalSign,
  modifyProducts,
  analytics,
  calls,
  boxesList,
  companiesList,
  vmails,
  companyGroupList,
  allBoxes,
  provisioning,
  deleteMode,
  home,
  totalBoxes,
  boxNotes,
  boxLogs,
  phone,
  unassignedBoxes,
  epikBoxLocations,
  companyGroupListDropdown,
  priSipData,
  alarmRelayStatus,
  tdmRoutes,
  enterpriseAdmins,
  requests,
  permissionGroups,
  permissionGroup,
});
